
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","d":"M8.998 11.5v1a.5.5 0 01-.5.5H5.996v2.002a.496.496 0 01-.31.455.498.498 0 01-.54-.105L2.144 12.35a.51.51 0 010-.71l3.002-3.002a.5.5 0 01.85.36V11h2.502a.5.5 0 01.5.5zm0-5.504H11v2.502a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V5.996h2.002a.499.499 0 00.36-.85L12.36 2.144a.51.51 0 00-.71 0L8.648 5.146a.499.499 0 00.35.85zm6.004 12.008H13v-2.502a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v2.502H8.997a.497.497 0 00-.455.31.498.498 0 00.105.54l3.002 3.002a.51.51 0 00.71 0l3.002-3.002a.5.5 0 00-.36-.85zm6.864-6.354l-3.002-3.002a.501.501 0 00-.86.35V11h-2.502a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h2.502v2.002c.002.2.124.38.31.455a.498.498 0 00.54-.105l3.002-3.002a.51.51 0 00.01-.7z","opacity":".75"}})])
          )
        }
      }
    